import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  icon: {
    minWidth: 32,
    color: colors.white,
  },
  selectedText: {
    fontWeight: 600,
    color: colors.white,
  },
  notSelected: {
    color: colors.white,
  },
}));

export default useStyles;
